import React from "react";

export default function About() {
    return (
        <>
            <h2>Hello ~ 👋</h2>
            <p>
                I am Amarjit Khan, a passionate technologist currently pursuing
                Master's in <mark>Cyber Security</mark> from the Computer Department at
                NIT Kurukshetra. I thrive on exploring new technologies and have a
                strong proficiency in <mark>full-stack web development</mark>. With a
                keen interest in building secure and efficient digital solutions, I
                enjoy solving complex problems and continuously expanding my skill set.
                Whether it's coding, cybersecurity, or exploring the latest tech trends,
                I am always eager to learn and innovate.
            </p>
            <p>
                I like minimalism and simplicity and I try to reflect that in my works
                as well. I often jam to music while working usually to genres like pop,
                synth, glitchcore, hyperpop, rock, and jpop. Meaningful and deep lyrics
                is what I look for in songs. According
                to last.fm, I have listened to his songs a total of 5157 times as of
                now. Apart from this I also like playing FPS games like <mark>VALORANT</mark>,
                lifting <mark>weights</mark>, and binge watching shows on netflix.
            </p>
            <br></br>
            <br></br>
            <h2>Skills ~ 🌟</h2>
            <p>
                I'm well-versed in the art of crafting digital experiences, juggling <mark>HTML, CSS, and JavaScript</mark> like
                second nature. My tech stack extends
                to <mark>Node.js, Express.js, React.js, Next.js, and TypeScript</mark>,
                making me right at home in the full-stack realm. I dabble in{" "}
                <mark>PHP and MySQL</mark>, keeping the old-school vibes alive, while{" "}
                <mark>MongoDB</mark> fuels my no-SQL adventures. When it comes to
                languages, I'm fluent in <mark>C, C++, Java, and Python</mark>, each
                adding its own flair to my problem-solving arsenal. And just for fun,
                I've dipped my toes into the world of <mark>Machine Learning</mark>
                —because why not? Always exploring, always learning.
            </p>
        </>
    );
}
